import script from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact-modal.vue?vue&type=script&setup=true&lang=ts"

import "./contact-modal.vue?vue&type=style&index=0&id=de15e10c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de15e10c"]])

export default __exports__